import type { RouteLocationRaw } from 'vue-router';
import type { EAnalyticsEvent } from '~/misc/services/analytics/types';
import { EFeatureName } from '~/misc/feature/types';

enum ERoute {
  NEW = 'search-new',
  ON_MARKET = 'search-on-market',
  ANNIVERSARY = 'search-anniversary',
  DOWNLOAD = 'download',
  WITHDRAWN = 'withdrawn',
  LIKELY_SOLD = 'likely-sold',
  AUTOMATED_EMAIL = 'automated-email',
}

type TNavLink = {
  title: string;
  to: string;
};

type TFeature = {
  title: string;
  to: RouteLocationRaw;
  privateName?: EFeatureName;
  hasDepartments?: boolean;
  analyticsEvent?: EAnalyticsEvent;
};

export type { TNavLink, TFeature };

export { ERoute };
